module.exports = __webpack_public_path__ + "img/as.b857441.svg";